import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { DatepickerService } from '../service/datepicker.service';


@Component({
  selector: 'app-year',
  templateUrl: './year.component.html',
  styleUrls: ['./year.component.css', '../date-time-picker.component.css']
})
export class YearComponent implements OnInit {
  @Input() field:any
  @Output() toggleYear = new EventEmitter();
  currentYear = new Date().getFullYear();
  showYear!:number;
  selectedYear!: number;
  activeYear!:number
  arrayYear!:number[];
  constructor(public datepicker_serv: DatepickerService) { }

  ngOnInit() {
    this.datepicker_serv.year.subscribe(
      (x) => {
        this.selectedYear = this.showYear = this.activeYear=x;
        this.arrayYear=this.yearRangeCal(x)
      }
    )

  }
  yearRangeCal(n: number) {
    let arr = []
    for (let i = 12; i > 0; i--) {
      arr.push(n - i)
    }
    arr.push(n)
    for (let i = 1; i <= 11; i++) {
      arr.push(n + i)
    }
    return arr
  }
  prevYear(){
    this.arrayYear=this.yearRangeCal(this.activeYear-=24);
  }
  nextYear(){
    this.arrayYear=this.yearRangeCal(this.activeYear+=24);

  }
  changeYear(y:number){
    this.datepicker_serv.year.next(y);
    this.toggleYear.emit()

  }

}
